import type { TFunction } from 'i18next';

export const CHARGE_TYPE = {
  DYNAMIC: 'DYNAMIC',
  OVERDUE: 'OVERDUE',
  PIX_CREDIARY: 'PIX_CREDIARY',
  PIX_CREDIT: 'PIX_CREDIT',
  ITP: 'ITP',
  CREDIT_CARD: 'CREDIT_CARD',
  BOLETO: 'BOLETO',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
};

export const getChargeTypes = (t: TFunction): Record<string, string> => ({
  [CHARGE_TYPE.DYNAMIC]: t('Pix Charge'),
  [CHARGE_TYPE.OVERDUE]: t('Pix Charge with deadline, fines and interest'),
  [CHARGE_TYPE.PIX_CREDIARY]: t('Pix Crediary'),
  [CHARGE_TYPE.PIX_CREDIT]: t('Charge with Pix and Credit Card'),
  [CHARGE_TYPE.ITP]: t('ITP Charge'),
  [CHARGE_TYPE.CREDIT_CARD]: t('Credit Card Charge'),
  [CHARGE_TYPE.BOLETO]: t('Boleto'),
  [CHARGE_TYPE.PAYMENT_METHOD]: t('Payment Methods'),
});
